import { queryClient } from 'queryClient';
import type { Country } from '@packages/domain/models/country';
import { queryKeys } from 'hooks/queryKeys';
import type { RootState } from 'reducers/types';
import { getCurrentLocale, getFieldValue } from 'selectors/ui/ui';
import { getRecipient } from '../recipient/recipient';

const NO_CURRENCY = {};

const getCurrencyObject = (state: RootState) => {
  const {
    entities: { currencies },
  } = state;

  return currencies;
};

export const getCurrency = (state: RootState, id: string) => {
  const { byId = {} } = getCurrencyObject(state);

  return byId[id] || NO_CURRENCY;
};

export const getCurrentCurrency = (state: RootState) => {
  const recipient = getRecipient(state);
  return getCurrency(state, recipient.currency as string);
};

export const getLocalCurrencyCode = (state: RootState) => {
  const countryCode = getFieldValue(state, 'sender_country');
  const countries =
    queryClient.getQueryData<Country[]>(
      queryKeys.countries.all(getCurrentLocale(state)),
    ) ?? [];
  return countries.find(c => c.code === countryCode)?.currency ?? '';
};

export const getLocalCurrency = (state: RootState) => {
  const localCurrencyCode = getLocalCurrencyCode(state);

  return getCurrency(state, localCurrencyCode);
};
